import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';

type UserAvatarProps = {
  size: number;
  hasAvatar: boolean;
  isLoggedIn: boolean;
  $isLinked: boolean;
};

export const UserAvatar = styled.div<UserAvatarProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: 600;
  font-size: ${p => Math.round(0.67 * p.size)}px;
  text-transform: uppercase;
  height: ${p => p.size}px;
  width: ${p => p.size}px;
  border-radius: ${p => p.size}px;
  transition: all ${layout.animations.buttonTransition};
  overflow: hidden;

  img {
    transition: all ${layout.animations.buttonTransition};
    border-radius: ${p => p.size}px;
  }

  svg path {
    fill: currentColor;
  }

  ${p =>
    p.isLoggedIn &&
    !p.hasAvatar &&
    css`
      background: ${p.theme.colors.base500};
      color: ${p.theme.colors.base0};

      ${p.$isLinked &&
      css`
        &:hover,
        .focus-visible & {
          color: ${p.theme.colors.base0};
          background: ${p.theme.icons.callToActionHover};
        }
      `}
    `};
`;

export const Image = styled.img`
  object-fit: cover;
  width: ${p => p.width}px;
  height: ${p => p.height}px;
`;
